import { render, staticRenderFns } from "./Batiment.vue?vue&type=template&id=35fb0862&scoped=true"
import script from "./Batiment.vue?vue&type=script&lang=js"
export * from "./Batiment.vue?vue&type=script&lang=js"
import style0 from "./Batiment.vue?vue&type=style&index=0&id=35fb0862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb0862",
  null
  
)

export default component.exports